import { useEffect, useState } from 'react';
import { NavLink, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Leaderboard from './pages/Leaderboard';
import Players from './pages/Players';
import Player from './pages/Player';
import Schedule from './pages/Schedule';
import Groups from './pages/Groups';
import Knockout from './pages/Knockout';
import Bets from './pages/Bets';
import BetDetail from './pages/BetDetail';
import News from './pages/News';
import HotPlayers from './pages/HotPlayers';
import MatchDetail from './pages/MatchDetail';
import TeamDetail from './pages/TeamDetail';
import Activity from './pages/Activity';
import TournamentPreds from './pages/TournamentPreds';
import Predictions from './pages/Predictions';
import PWAInstallBanner from './components/PWAInstallBanner';
import PullToRefresh from './components/PullToRefresh';
import LiveTicker from './components/LiveTicker';
import ConfettiContainer from './components/Confetti';
import BetWinWatcher from './components/BetWinWatcher';
import TournamentStartWatcher from './components/TournamentStartWatcher';
import GlobalHaptics from './components/GlobalHaptics';
import KeyboardShortcuts from './components/KeyboardShortcuts';
import ShakeToRefresh from './components/ShakeToRefresh';
import PWABadge from './components/PWABadge';
import Settings from './pages/Settings';
import ToastContainer from './toast';

interface NavItem {
  to: string;
  label: string;
  short: string;
  icon: string;
  primary: boolean;
}

interface NavBuild { label: string; to: string; short: string; primary: boolean; icon: string }
const NAV_RAW: NavBuild[] = [
  { label: 'Standings',           to: '/leaderboard', short: 'Stand.', primary: true,  icon: 'M3 13h4v8H3zM10 5h4v16h-4zM17 9h4v12h-4z' },
  { label: 'Activity',            to: '/activity',    short: 'Activ.', primary: true,  icon: 'M3 12h4l3 -9 4 18 3 -9h4' },
  { label: 'Bets',                to: '/bets',        short: 'Bets',   primary: true,  icon: 'M12 2v20M5 7h12a3 3 0 010 6H7a3 3 0 000 6h12' },
  { label: 'Schedule',            to: '/schedule',    short: 'Sched.', primary: true,  icon: 'M7 2v3M17 2v3M3 8h18M5 6h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z' },
  { label: 'Players',             to: '/players',     short: 'Plyrs',  primary: false, icon: 'M12 3a4 4 0 100 8 4 4 0 000-8zM4 21a8 8 0 0116 0H4z' },
  { label: 'News',                to: '/news',        short: 'News',   primary: false, icon: 'M4 4h16v16H4zM8 8h8M8 12h8M8 16h5' },
  { label: 'Hottest players',     to: '/hot',         short: 'Hot',    primary: false, icon: 'M12 2c2 3 0 5-1 7s-1 5 1 7c3-3 6-7 6-11a6 6 0 00-6-6 6 6 0 00-6 6c0 4 3 8 6 11-2-2-2-5-1-7s-1-4-1-7z' },
  { label: 'Groups',              to: '/groups',      short: 'Groups', primary: false, icon: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z' },
  { label: 'Knockout',            to: '/knockout',    short: 'Cup',    primary: false, icon: 'M8 2h8l-1 7a3 3 0 11-6 0L8 2zM5 4H3v3a3 3 0 003 3M19 4h2v3a3 3 0 01-3 3M9 14h6M10 18h4M9 22h6' },
  { label: 'Side games',          to: '/predictions', short: 'Side',   primary: false, icon: 'M9 11l3 3 8 -8M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11' },
  { label: 'Tournament predictions', to: '/tournament', short: 'T-Pred', primary: false, icon: 'M12 2l3 6 7 1-5 4 1 7-6-3-6 3 1-7-5-4 7-1z' },
  { label: 'Settings',                to: '/settings',   short: 'Set.',   primary: false, icon: 'M12 8a4 4 0 100 8 4 4 0 000-8zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 008 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 8a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z' },
];

export default function App() {
  return (
    <div className="min-h-dvh flex flex-col lg:flex-row">
      <LiveTicker />
      <Sidebar />
      <main className="flex-1 app-safe-area pb-4 lg:pb-10 lg:pl-8 lg:pr-8 pt-4 lg:pt-8 max-w-screen-2xl w-full mx-auto">
        <Routes>
          <Route path="/" element={<Navigate to="/leaderboard" replace />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/players" element={<Players />} />
          <Route path="/players/:name" element={<Player />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/groups" element={<Groups />} />
          <Route path="/knockout" element={<Knockout />} />
          <Route path="/bets" element={<Bets />} />
          <Route path="/bets/:id" element={<BetDetail />} />
          <Route path="/news" element={<News />} />
          <Route path="/hot" element={<HotPlayers />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/tournament" element={<TournamentPreds />} />
          <Route path="/predictions" element={<Predictions />} />
          <Route path="/matches/:id" element={<MatchDetail />} />
          <Route path="/teams/:code" element={<TeamDetail />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/leaderboard" replace />} />
        </Routes>
      </main>
      <BottomTabs />
      <PWAInstallBanner />
      <PullToRefresh />
      <ToastContainer />
      <ConfettiContainer />
      <BetWinWatcher />
      <TournamentStartWatcher />
      <GlobalHaptics />
      <KeyboardShortcuts />
      <ShakeToRefresh />
      <PWABadge />
    </div>
  );
}

function Sidebar() {
  return (
    <aside className="hidden lg:flex lg:flex-col lg:w-64 lg:shrink-0 lg:gap-1 lg:p-6 lg:border-r lg:border-ink-800 lg:bg-ink-900/40 lg:sticky lg:top-0 lg:h-dvh lg:overflow-y-auto">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-dim">Fantasy</div>
        <div className="font-display text-2xl font-semibold leading-none mt-1">
          World Cup <span className="text-pitch-400">2026</span>
        </div>
      </div>
      {NAV_RAW.map((n) => (
        <NavLink key={n.to} to={n.to} className="nav-link">
          <Icon path={n.icon} /> {n.label}
        </NavLink>
      ))}
    </aside>
  );
}

function BottomTabs() {
  const [moreOpen, setMoreOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setMoreOpen(false); }, [pathname]);

  const primary = NAV_RAW.filter((n) => n.primary);
  const more = NAV_RAW.filter((n) => !n.primary);
  const moreActive = more.some((n) => pathname.startsWith(n.to));

  return (
    <>
      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-ink-950 border-t border-ink-800"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        <div className="grid grid-cols-5 h-[3.75rem]">
          {primary.map((n) => (
            <NavLink key={n.to} to={n.to} className="tab-link">
              <Icon path={n.icon} />
              <span className="text-[10px]">{n.short}</span>
            </NavLink>
          ))}
          <button
            type="button"
            onClick={() => setMoreOpen((v) => !v)}
            className={`tab-link ${moreActive || moreOpen ? 'text-pitch-400' : ''}`}
            aria-haspopup="menu"
            aria-expanded={moreOpen}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <circle cx="5" cy="12" r="1.6" />
              <circle cx="12" cy="12" r="1.6" />
              <circle cx="19" cy="12" r="1.6" />
            </svg>
            <span className="text-[10px]">{'More'}</span>
          </button>
        </div>
      </nav>

      {moreOpen && (
        <div
          className="lg:hidden fixed inset-0 z-40 bg-black/60 flex items-end"
          onClick={() => setMoreOpen(false)}
        >
          <div
            className="w-full bg-ink-900 border-t border-ink-800 rounded-t-3xl p-4 pb-8"
            style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 5.5rem)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-10 h-1 rounded-full bg-ink-700 mx-auto mb-4" />
            <div className="text-[10px] uppercase tracking-widest text-dim mb-2 px-1">{'More'}</div>
            <div className="space-y-1">
              {more.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  className="flex items-center gap-3 px-3 py-3 rounded-lg text-chalk hover:bg-ink-800 active:bg-ink-700"
                >
                  <Icon path={n.icon} /> {n.label}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function Icon({ path }: { path: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={path} />
    </svg>
  );
}
